<template>
  <div class="flex-col">
    <div class="menu_container flex-row">
      <div
        class="menu_item flex-row"
        :class="{ menu_active: idx == 0 }"
        @click="menuNavigator(0)"
      >
        <img
          class="menu_icon"
          referrerpolicy="no-referrer"
          src="../../assets/components/menu/FigmaDDSSlicePNG7d9a7cd68b0b6a6828c5c0f9dffc2de4.png"
        />
        <span class="menu_text">课堂</span>
      </div>
      <div
        class="menu_item flex-row"
        :class="{ menu_active: idx == 1 }"
        @click="menuNavigator(1)"
      >
        <img
          class="menu_icon"
          referrerpolicy="no-referrer"
          src="../../assets/components/menu/FigmaDDSSlicePNGcadc60c50e67a4637eef2fce42b69205.png"
        />
        <span class="menu_text">学生</span>
      </div>
      <div
        class="menu_item flex-row"
        :class="{ menu_active: idx == 2 }"
        @click="menuNavigator(2)"
      >
        <img
          class="menu_icon"
          referrerpolicy="no-referrer"
          src="../../assets/components/menu/FigmaDDSSlicePNGa86c6816ba23ed759ed4eeb3d554ee2f.png"
        />
        <span class="menu_text">任务</span>
      </div>
      <div
        class="menu_item flex-row"
        :class="{ menu_active: idx == 3 }"
        @click="menuNavigator(3)"
      >
        <img
          class="menu_icon"
          referrerpolicy="no-referrer"
          src="../../assets/components/menu/FigmaDDSSlicePNGfabe0911244dfd5a07bb42d3645e9170.png"
        />
        <span class="menu_text">教程</span>
      </div>
      <div
        class="menu_item_long flex-row"
        :class="{ menu_active: idx == 4 }"
        @click="menuNavigator(4)"
      >
        <img
          class="menu_icon"
          referrerpolicy="no-referrer"
          src="../../assets/components/menu/FigmaDDSSlicePNG10aebe6fe7e68b801c557d864d6b86ed.png"
        />
        <span class="menu_text">教学资源</span>
      </div>
    </div>
    <div class="divider_container flex-row">
      <div class="menu_divider flex-col"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue"
import { useRoute, useRouter } from "vue-router"

const route = useRoute()
const router = useRouter()
const idx = ref(0)
const routes = [
  "Records",
  "RecordsStudents",
  "RecordsTask",
  "Plan",
  "Resources",
]

const menuNavigator = (index) => {
  if (index >= 0 && index < routes.length) {
    let lessonId = route.query.lessonId
    if (!lessonId) {
      alert("参数错误，请先选择课程")
      router.push("/teacher/courses")
      return
    }
    router.push({
      name: routes[index],
      query: {
        lessonId: lessonId,
      },
    })
  }
}

onMounted(() => {
  switch (route.name) {
    case "Records":
      idx.value = 0
      break
    case "RecordsStudents":
      idx.value = 1
      break
    case "RecordsTask":
      idx.value = 2
      break
    case "Plan":
      idx.value = 3
      break
    case "Resources":
      idx.value = 4
      break
    default:
      idx.value = 0
  }
})

watch(
  () => route.name,
  (newName, oldName) => {
    switch (newName) {
      case "Records":
        idx.value = 0
        break
      case "RecordsStudents":
        idx.value = 1
        break
      case "RecordsTask":
        idx.value = 2
        break
      case "Plan":
        idx.value = 3
        break
      case "Resources":
        idx.value = 4
        break
      default:
        idx.value = 0
    }
  }
)
</script>

<style scoped>
.menu_container {
  width: 25vw;
  height: 2.77vw;
  margin: 0;
}

.menu_item {
  background-color: transparent;
  width: 6.5vw;
  height: 2.77vw;
  margin: 0vw 1vw 0 0;
  cursor: pointer;
}

.menu_item_long {
  background-color: transparent;
  width: 8.5vw;
  height: 2.77vw;
  margin: 0vw 1vw 0 0;
  cursor: pointer;
}

.menu_active {
  background-color: rgba(104, 162, 250, 0.2);
  border-radius: 0.99vw 0.99vw 0 0;
}

.menu_icon {
  width: 1.6667vw;
  height: 1.6667vw;
  margin: 0.55vw 0 0 1vw;
}

.menu_text {
  width: 2.0833vw;
  height: 1.3542vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.0417vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.0417vw;
  margin: 0.88vw 0 0 0.5vw;
}

.divider_container {
  width: 81vw;
  height: 0.1042vw;
  margin: 0;
}

.menu_divider {
  background-color: rgba(217, 217, 217, 1);
  width: 81vw;
  height: 0.1042vw;
}
</style>
